<!-- 全域 Loading -->
<ng-container *ngIf="!isOptionLoading; else globalLoading">
  <app-nav-header [CompanyID]="CompanyID" [UserID]="UserID" [Liff_ID]="Liff_ID" [title]="'住宿預約'"></app-nav-header>

  <main [ngSwitch]="Step" class="container-fluid p-3">
    
    <!-- STEP 0: 同意書與簽名 -->
    <section *ngSwitchCase="0" class="step-card">
      <p-scrollPanel #consentFormScrollPanel [style]="{ width: '100%', height: '300px' }" styleClass="border-1 surface-border border-round p-3">
        <p class="text-justify line-height-3" style="white-space: pre-wrap; word-wrap: break-word;">
          {{ consentFormContent }}
        </p>
      </p-scrollPanel>

      <div class="mt-3">
        <div class="sign-container border-1 surface-border border-round mb-2">
          <ngx-signature-pad #sig [options]="options" class="sign-canvas" 
            [class.disabled]="!isConsentFormRead"
            (beginSign)="onBegin()" (endSign)="onEnd()">
          </ngx-signature-pad>
        </div>
        <div class="p-2 w-full"> <!-- 增加一點 padding 防止按鈕貼死螢幕邊緣 -->
          <button pButton 
                  type="button"
                  label="清除簽名" 
                  icon="pi pi-trash" 
                  class="p-button-secondary w-full p-3 text-lg" 
                  [disabled]="!isConsentFormRead" 
                  (click)="clear()">
          </button>
        </div>
      </div>

      <div class="my-4 flex justify-content-center" style="text-align: center;">
        <p-checkbox name="agree" label="我已閱讀並同意此條款" [(ngModel)]="isAgreed" [binary]="true" [disabled]="!CheckSign()"></p-checkbox>
      </div>

      <app-button appClass="pageForm__btn w-full py-3" (appClick)="nextStep(0)" appLabel="確定並下一步" [loading]="isLoading" [disabled]="!isAgreed"></app-button>
      
    </section>

    <!-- STEP 1: 預約表單 -->
    <section *ngSwitchCase="1">
      <form class="pageForm grid p-fluid">
        <!-- 門市選擇 -->
        <div class="field col-12">
          <label starSign class="font-bold mb-2">預約門市</label>
          <p-dropdown *ngIf="StoreSelectList != null" 
            [options]="StoreSelectList" name="StoreNo" 
            [(ngModel)]="model.StoreNo" placeholder="請選擇門市" 
            [showClear]="true" appendTo="body" 
            (ngModelChange)="GetBookedAndResetRoomType()"
          ></p-dropdown>
        </div>

        <div class="field col-12">
          <label starSign class="font-bold mb-2">入住日期</label>
          <p-calendar 
            [(ngModel)]="model.ResDateS"  styleClass="w-full"  inputStyleClass="w-full"
            [minDate]="resMinDate" name="ResDateS"
            [disabledDays]="disabledDays"  [disabled]="!model.StoreNo"
            [disabledDates]="disabledDates" placeholder="選擇日期"
            [readonlyInput]="true"
            dateFormat="yy-mm-dd"
            (onSelect)="ToCalculate()"
            (onClose)="GetBookedAndResetRoomType()">
          </p-calendar>
        </div>

        <div class="field col-12">
          <label starSign class="font-bold mb-2">退房日期</label>
          <p-calendar 
            [(ngModel)]="model.ResDateE"  styleClass="w-full"  inputStyleClass="w-full"
            [minDate]="resMinDate" name="ResDateE"
            [disabledDays]="disabledDays"  [disabled]="!model.StoreNo"
            [disabledDates]="disabledDates" placeholder="選擇日期"
            [readonlyInput]="true"
            dateFormat="yy-mm-dd"
            (onSelect)="ToCalculate()"
            (onClose)="GetBookedAndResetRoomType()">
          </p-calendar>
        </div>

        <!-- 房型與寵物 -->
        <div class="field col-12">
          <label starSign class="font-bold mb-2">預約房型</label>
          <p-dropdown *ngIf="RoomTypeSelectList != null" 
            [options]="RoomTypeSelectList" 
            [(ngModel)]="model.RoomType" placeholder="請選擇房型" 
            [showClear]="true" 
            (ngModelChange)="SelectRoomType()" name="RoomType" 
            [disabled]="!isRoomOpen()"
          ></p-dropdown>
        </div>

        <div class="field col-12">
          <label starSign class="font-bold mb-2">選擇寵物</label>
          <p-dropdown *ngIf="PetSelectList != null" [options]="PetSelectList" [(ngModel)]="model.PetNo" placeholder="請選擇寵物" [showClear]="true" 
             name="PetNo"></p-dropdown>
        </div>

        <!-- 費用與訊息 -->
        <div class="field col-12 flex align-items-center gap-2">
          <span class="font-bold">估計總金額：</span>
          <span class="text-2xl text-primary font-bold">NT$ {{ TotalPrice| number }}</span>
        </div>

        <div class="col-12" *ngIf="showErr || (model.ResDateS && model.ResDateE && !isDateRangeBookable())">
          <!-- API 報錯 (如客滿) -->
          <p-message *ngIf="showErr" severity="error" [text]="ErrMsg" styleClass="w-full mb-2"></p-message>
          
          <!-- 日期區間含休假警告 -->
          <p-message *ngIf="model.ResDateS && model.ResDateE && !isDateRangeBookable()" 
            severity="warn" text="所選區間包含門市休假日，請重新調整日期" styleClass="w-full">
          </p-message>
        </div>

        <div class="col-12 mt-3">
          <app-button 
            appClass="pageForm__btn w-full py-3" 
            (appClick)="nextStep(1)" appLabel="下一步" 
            [loading]="isLoading" 
            [disabled]="!isStep1Ready()"
          ></app-button>
        </div>
      </form>
    </section>

    <!-- STEP 2: 確認資訊 -->
    <section *ngSwitchCase="2" class="step-card">
      <div class="surface-ground border-round p-4 mb-4">
        <h3 class="mt-0 mb-4 text-center">核對預約資訊</h3>
        <dl class="info-list">
          <div class="flex justify-content-between mb-2"><dt class="text-secondary">入住日期：</dt><dd class="font-bold">{{editModel.ResDateS}}</dd></div>
          <div class="flex justify-content-between mb-2"><dt class="text-secondary">退房日期：</dt><dd class="font-bold">{{editModel.ResDateE}}</dd></div>
          <div class="flex justify-content-between mb-2"><dt class="text-secondary">預約門市：</dt><dd class="font-bold">{{editModel.StoreName}}</dd></div>
          <div class="flex justify-content-between mb-2"><dt class="text-secondary">預約房型：</dt><dd class="font-bold">{{editModel.RoomTypeName}}</dd></div>
          <div class="flex justify-content-between mb-2"><dt class="text-secondary">寵物名稱：</dt><dd class="font-bold">{{editModel.PetName}}</dd></div>
          <hr class="surface-border" />
          <div class="flex justify-content-between mt-2"><dt class="text-lg">預計費用：</dt><dd class="text-lg font-bold text-primary">NT$ {{editModel.Price}}</dd></div>
        </dl>
      </div>

      <div class="flex flex-column gap-2 mt-5">
          <app-button appClass="pageForm__btn w-full" (appClick)="nextStep(2)" [appLabel]="'確認預約'" [loading]="isLoading"></app-button>
          <app-button appClass="p-button-text w-full" (appClick)="prevStep()" appLabel="返回修改" [disabled]="!isFirstStepFinish()"></app-button>
      </div>
    </section>

    <!-- STEP 3: 完成 -->
    <section *ngSwitchCase="3">
      <ng-container *ngIf="!isFinalLoading; else stepLoading">
        <div class="text-center mb-4">
          <i class="pi pi-check-circle text-6xl text-success mb-3"></i>
          <h2 class="mt-0">{{UserName}}，預約成功!</h2>
        </div>

        <div class="surface-card shadow-1 border-round p-4 mb-4">
          <ul class="list-none p-0 m-0">
            <li class="flex py-2 border-bottom-1 surface-border">
              <span class="text-secondary w-8rem">入住 / 退房：</span>
              <span class="font-bold">{{editModel.ResDateS}} ~ {{editModel.ResDateE}}</span>
            </li>
            <li class="flex py-2 border-bottom-1 surface-border">
              <span class="text-secondary w-8rem">預約門市：</span>
              <span class="font-bold">{{editModel.StoreName}}</span>
            </li>
            <li class="flex py-2 border-bottom-1 surface-border">
              <span class="text-secondary w-8rem">預約房型：</span>
              <span class="font-bold">{{editModel.RoomTypeName}}</span>
            </li>
            <li class="flex py-2" *ngIf="RemitInfo">
              <span class="text-secondary w-8rem">匯款資訊：</span>
              <span class="text-primary font-bold">{{RemitInfo}}</span>
            </li>
          </ul>
        </div>

        <app-button 
          appClass="pageForm__btn w-full py-3" 
          (appClick)="nextStep(3)" 
          appLabel="返回預約首頁" 
          [loading]="isLoading"
        ></app-button>
      </ng-container>
    </section>

    <!-- 預設 Loading -->
    <ng-template #stepLoading>
      <div class="flex justify-content-center align-items-center py-8">
        <p-progressSpinner strokeWidth="4"></p-progressSpinner>
      </div>
    </ng-template>

    <div *ngSwitchDefault class="text-center py-8">資料加載中...</div>
  </main>
</ng-container>

<ng-template #globalLoading>
  <div class="flex flex-column justify-content-center align-items-center h-screen">
    <p-progressSpinner></p-progressSpinner>
  </div>
</ng-template>
